//#region react imports
import { useState } from "react";
import { useSelector } from "react-redux";
//#endregion

//#region functions imports
import { getTranslations } from "../../Helper/TranslationController";
//#endregion

//#region components imports
import Documentation from "../Documentation/Documentation.component";
import DocumentationMenu from "../DocumentationMenu/DocumentationMenu.component";
//#endregion

//#region constants imports
import { ICON_D1B_PICTO, ICON_INFO } from "../../Constants/IconConstants";
import { TRANSLATIONS } from "../../Constants/Translations";
//#endregion

//#region style imports
import "./DocumentationModalContent.style.scss";
//#endregion

const DocumentationModalContent = () => {
  //#region hooks
  const translations = useSelector((state) => state.translationSlice.translations);
  const docTranslationKey = useSelector((state) => state.translationSlice.docTranslationKey);
  //#endregion

  //#region state
  const [selectedMenu, setSelectedMenu] = useState(
    docTranslationKey?.Documentation?.GeneralDocumentation
      ? Object.keys(docTranslationKey?.Documentation?.GeneralDocumentation)[0]
      : null
  );
  const [machineName, setMachineName] = useState(null);
  //#endregion

  //#region functions
  const clickOnGenral = (menuName) => {
    setSelectedMenu(menuName);
    setMachineName(null);
  };

  const clickOnSimulation = (menuName) => {
    setSelectedMenu(menuName);
    setMachineName(menuName);
  };
  const renderDocumentation = () => {
    const section =
      docTranslationKey?.Documentation?.GeneralDocumentation?.[selectedMenu] ||
      docTranslationKey?.Documentation?.SimulationDocumentation?.[selectedMenu];
    return selectedMenu && section
      ? Object.entries(section).map(([title, links]) => (
          <Documentation
            key={`${selectedMenu}_${title}`}
            title={title}
            links={links}
            machineName={machineName}
          />
        ))
      : null;
  };
  //#endregion
  return (
    <section className="documentation-content">
      <div className="documentation-content-menu">
        {docTranslationKey?.Documentation?.GeneralDocumentation && (
          <DocumentationMenu
            iconTitle={<i className={ICON_INFO} />}
            title={getTranslations(TRANSLATIONS.DOCUMENTATION_GENERAL, translations)}
            content={docTranslationKey?.Documentation?.GeneralDocumentation}
            documentToShow={selectedMenu}
            setDocumentsToShow={clickOnGenral}
          />
        )}
        {docTranslationKey?.Documentation?.SimulationDocumentation && (
          <DocumentationMenu
            iconTitle={<i className={ICON_D1B_PICTO} />}
            title={getTranslations(TRANSLATIONS.DOCUMENTATION_SIMULATION, translations)}
            content={docTranslationKey?.Documentation?.SimulationDocumentation}
            documentToShow={selectedMenu}
            setDocumentsToShow={clickOnSimulation}
            isMachineDocumentation
          />
        )}
      </div>
      <div className="documentation-content-separator" />
      <div className="documentation-content-links">{renderDocumentation()}</div>
    </section>
  );
};

export default DocumentationModalContent;
